import { render, staticRenderFns } from "./BirthdayTagIcon.vue?vue&type=template&id=1587c3da&"
import script from "./BirthdayTagIcon.vue?vue&type=script&lang=ts&"
export * from "./BirthdayTagIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports